module.exports = __webpack_public_path__ + "media/theme/sample-card__psn-c13682ce.png";